<div class="table-responsive">
    <table class="table table-bordered">
        <thead>
            <tr>
                <td>Brand name</td>
                <td>Model name</td>
                <td>Model Qualifier</td>
                <td>Number of units</td>
                <td>Select</td>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of result">
                <td class="col-4">{{ item?.value?.brandName }}</td>
                <td class="col-3">{{ item?.value?.modelName }}</td>
                <td class="col-3">{{ item.value?.modelQualifier }}</td>
                <td class="col-1"><input type="number" class="form-control input-sm" [(ngModel)]="item.numberOfHeaters" (change)="selectPcdbData(item)" min="0" max="4" /></td>
                <td class="col-1"><input type="checkbox" class="form-check-input" [(ngModel)]="item.selected" (change)="selectPcdbData(item)" /></td>
            </tr>
        </tbody>
    </table>
</div>
